import { defineMessages } from 'react-intl';

export const MeterIdentificationPage = defineMessages({
  meterIdentification: {
    id: 'app.common.meterIdentification',
    defaultMessage: 'Identifikace měřidla',
  },
  meterNotFoundByStrapiId: {
    id: 'app.MeterIdentificationPage.meterNotFoundByStrapiId',
    defaultMessage: 'Měřidlo se zadaným Strapi ID nebylo nalezen',
  },
  meterFound: {
    id: 'app.MeterIdentificationPage.meterFound',
    defaultMessage: 'Měřidlo nalezeno',
  },
  meterErrorWithStrapiId: {
    id: 'app.MeterIdentificationPage.meterErrorWithStrapiId',
    defaultMessage: 'Nastal problém při hledání měřidla podle Strapi ID',
  },
  meterErrorWithQRCode: {
    id: 'app.MeterIdentificationPage.meterErrorWithQRCode',
    defaultMessage: 'Nastal problém při hledání měřidla podle hodnoty QR kódu',
  },
  meterError: {
    id: 'app.MeterIdentificationPage.meterError',
    defaultMessage: 'Měřidlo nebylo nalezeno',
  },
  findError: {
    id: 'app.MeterIdentificationPage.findError',
    defaultMessage: 'Špatně zadané Strapi ID / API klíč',
  },
  enterMeterId: {
    id: 'app.MeterIdentificationPage.enterMeterId',
    defaultMessage: 'Zadejte Strapi ID měřidla',
  },
  enterMeterIdTooltip: {
    id: 'app.MeterIdentificationPage.enterMeterIdTooltip',
    defaultMessage: 'Strapi ID můžeš najít v detailu měřidla v Enmon Tools',
  },
  scanOrEnterMeterId: {
    id: 'app.MeterIdentificationPage.scanOrEnterMeterId',
    defaultMessage: 'Naskenujte QR kód nebo zadejte Strapi ID',
  },
  scanQrCode: {
    id: 'app.MeterIdentificationPage.scanQrCode',
    defaultMessage: 'Naskenujte QR kód',
  },
  scanQrCodeTooltip: {
    id: 'app.MeterIdentificationPage.scanQrCodeTooltip',
    defaultMessage: 'Api Key měřidla můžeš naskenovat přes QR čtečku',
  },
  scanQrCodeSuccess: {
    id: 'app.MeterIdentificationPage.scanQrCodeSuccess',
    defaultMessage: 'QR kód úspěšně naskenován',
  },
});

export const MeterIdentificationFooter = defineMessages({
  confirm: {
    id: 'app.common.confirm',
    defaultMessage: 'Potvrdit',
  },
});
